import { SearchOutlined } from "@ant-design/icons";
import type { ProColumns } from "@ant-design/pro-components";
import { Button, Input, Space } from "antd";

export type TextHeaderFilterActionLabels = {
  search: string;
  reset: string;
};

export function buildLocalizedTextHeaderFilter(
  placeholder: string,
  actionLabels: TextHeaderFilterActionLabels,
): Pick<ProColumns<unknown>, "filterIcon" | "filterDropdown"> {
  return {
    filterIcon: <SearchOutlined />,
    filterDropdown: (props) => {
      const { selectedKeys, setSelectedKeys, confirm, clearFilters, close } = props;
      return (
        <div style={{ padding: 8, width: 260 }}>
          <Input
            allowClear
            autoFocus
            placeholder={placeholder}
            value={String(selectedKeys[0] ?? "")}
            onChange={(event) => {
              const nextValue = event.target.value;
              setSelectedKeys(nextValue ? [nextValue] : []);
            }}
            onPressEnter={() => {
              confirm();
              close();
            }}
          />
          <Space style={{ marginTop: 8 }}>
            <Button
              size="small"
              color="primary"
              variant="solid"
              onClick={() => {
                confirm();
                close();
              }}
            >
              {actionLabels.search}
            </Button>
            <Button
              size="small"
              onClick={() => {
                clearFilters?.();
                confirm();
                close();
              }}
            >
              {actionLabels.reset}
            </Button>
          </Space>
        </div>
      );
    },
  };
}
